<template>
  <v-card :loading="loading" flat>
    <v-card-title>
      <v-spacer />
      مدیریت گزارش کار
      <v-spacer />
      <!--          <v-btn :loading="loading" @click="getData(url)" class="btn-update">-->
      <!--            <v-icon>mdi-refresh</v-icon>-->
      <!--            به روزرسانی-->
      <!--          </v-btn>-->
    </v-card-title>
    <v-divider />

    <v-row no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.length"
          :items="[10, 25, 50, 100, 200, 400]"
          dense
          editable
          hide-details
          label="تعداد نمایش"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-autocomplete
          v-model="tableProps.user_id"
          :items="users"
          auto-select-first
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          editable
          hide-details
          label="انتخاب کاربر"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <date-picker
          v-model="tableProps.created_at"
          display-format="jYYYY-jMM-jDD"
          format="YYYY-MM-DD"
          label="تاریخ ثبت"
          v-on:input="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="tableProps.search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="جستجو"
          outlined
          @keydown.enter="reloadTable()"
          @click:append="reloadTable()"
          @click:clear="clearFilter"
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <data-table :columns="columns" :data="data" :translate="translates">
          <div slot="filters" />

          <div slot="pagination">
            <pagination
              v-if="data && data.data"
              ref="pagination"
              :data="data"
              @page="onPagination"
            >
              <template v-slot:per-page>
                <v-select
                  v-model="tableProps.length"
                  :items="[10, 25, 50, 100, 400]"
                  :menu-props="{ offsetY: true }"
                  class="ma-2 my-md-0"
                  dense
                  label="تعداد نمایش"
                  outlined
                  @change="onPerPage"
                />
              </template>
            </pagination>
          </div>
        </data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";
import Pagination from "../../pickers/pagination";

export default {
  components: { Pagination },
  data() {
    return {
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
          transform: (val) => {
            return val.data.user.name + "  " + val.data.user.lastName;
          },
        },
        {
          name: "start_date",
          label: "ساعت شروع",
          orderable: true,
          transform: (value) => {
            return value.data.start_date !== null
              ? this.$options.filters.longDate(value.data.start_date)
              : "نامعلوم";
          },
        },

        {
          name: "end_date",
          label: "ساعت پایان",
          orderable: true,
          transform: (value) => {
            return value.data.end_date !== null
              ? this.$options.filters.longDate(value.data.end_date)
              : "نامعلوم";
          },
        },

        {
          name: "company_presence",
          label: "حضوری/دورکاری",
          transform: (value) => {
            return value.data.company_presence == "present"
              ? "حضوری"
              : "دورکاری";
          },
        },

        {
          label: "مرخصی ساعتی",
          name: "vacation",
          orderable: true,
          transform: (val) => {
            return val.data.vacation_start_date !== null ? "دارد" : "ندارد";
          },
        },
        {
          label: "کارکرد ساعتی",
          name: "start_hour",
          orderable: true,
          transform: (val) => {
            return val.data.start_hour !== null ? "دارد" : "ندارد";
          },
        },

        {
          label: "زمان استفاده شده برای آموزش",
          name: "learning_time",
          orderable: true,
          transform: (val) => {
            return val.data.learning_time + "ساعت ";
          },
        },

        {
          label: "توضیحات",
          name: "description",
          orderable: true,
          transform: (val) => {
            return val.data.description.length > 10
              ? val.data.description.substring(0, 10) + " ..."
              : val.data.description;
          },
        },

        // {
        //   label: 'تاریخ ویرایش',
        //   name: 'updated_at',
        //   transform: (val) => {
        //     return this.$options.filters.longDate(val.data.updated_at)
        //   }
        // },

        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "AdminworkReports_",
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              // {
              //   name: 'show',
              //   label: 'نمایش',
              //   icon: 'eye',
              //   class:'btn-outline-info',
              // }
            ],
          },
        },
      ],
      created_at: null,
      data: {},
      url: "admin/workReports",
      loading: false,
      users: [],
      user_id: null,
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
        user_id: null,
        created_at: null,
      },
      query: { sort: "id", order: "desc", limit: 25, s: "" },
    };
  },

  created() {
    this.getData(this.url);
    this.employees();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  methods: {
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.getData();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    clearFilter() {
      this.tableProps.page = 1;
      this.$nextTick(() => {
        this.reloadTable();
      });
    },
    getData(url = this.url, options = this.tableProps) {
      this.loading = true;
      // {user_id:this.user_id,created_at:this.created_at}
      this.requestApiGet(this.url, options)
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => (this.loading = false));
    },
    employees() {
      this.loading = true;
      this.requestApiGet("admin/workReports/employees")
        .then((response) => {
          this.users = response.data;
          let users = [];
          for (let i = 0; i < response.data.length; i++) {
            users.push({
              text: response.data[i].name + " " + response.data[i].lastName,
              value: response.data[i].id,
            });
          }
          this.users = users;
        })
        .finally(() => (this.loading = false));
    },
    reloadTable(tableProps = this.tableProps) {
      this.tableProps.page = 1;
      this.$nextTick(() => {
        this.getData(this.url, tableProps);
      });
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({
        name: "admin.workReports.edit",
        params: { id: data.id },
      });
    },
  },

  beforeDestroy() {
    this.resetState();
  },
};
</script>
